const categories = [
  {
    name: "Investigations",
    description: "Videos and photos amet, con sectetur in congue.",
    slug: "investigations",
    icon: "camera",
    color: "#28b7af",
  },
  // {
  //   name: "Graphics",
  //   description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
  //   slug: "graphics",
  //   icon: "pen-tool",
  //   color: "#e86a85",
  // },
  {
    name: "Videos",
    description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
    slug: "videos",
    icon: "film",
    color: "#e86a85",
  },
  {
    name: "Photos",
    description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
    slug: "photos",
    icon: "image",
    color: "#9673cc",
  },
  // {
  //   name: "IT solutions",
  //   description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
  //   slug: "it-solutions",
  //   icon: "command",
  //   color: "#549cd1",
  // },
  // {
  //   name: "PR templates",
  //   description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
  //   slug: "pr-templates",
  //   icon: "file",
  //   color: "#f08440",
  // },
  {
    name: "Projects for adaptation",
    description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
    slug: "projects-for-adaptation",
    icon: "package",
    color: "#f08440",
  },
  {
    name: "Articles",
    description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
    slug: "articles",
    icon: "file-text",
    color: "#549cd1",
  },
  {
    name: "Talks and lectures",
    description: "Lorem ipsum dolor sit amet, con sectetur in congue.",
    slug: "talks-and-lectures",
    icon: "book-open",
    color: "#30bc52",
  },
]

module.exports = categories
